import * as React from "react";
import { Paper } from "@mui/material";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import Avatar from "@mui/material/Avatar";
import Profile from "../static/icons/profile.png";
import PeygiriSefaresh from "../static/icons/peygirisefaresh.png";
import Dastebandiha from "../static/icons/dastebandiha.png";
import Eftekharat from "../static/icons/eftekharat.png";
import TamasBaMa from "../static/icons/tamasbama.png";

export default function AppBottomNavigation({
  handleRightMenu,
  handleComToShow,
}) {
  const [value, setValue] = React.useState(2);

  return (
    <Paper
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        paddingBottom: 1.5,
        "& .muirtl-4wdd6p-MuiBottomNavigation-root": {
          backgroundColor: "#2e2d2b",
        },
      }}
      elevation={5}
    >
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
          console.log(newValue);
        }}
        sx={{ height: 76, backgroundColor: "#2e2d2b" }}
      >
        {[
          { menuText: "پروفایل", icon: Profile, compName: "userprofile" },
          {
            menuText: "پیگیری‌ها",
            icon: PeygiriSefaresh,
            compName: "peygiriha",
          },
          { menuText: "خانه", icon: Dastebandiha, compName: "" },
          { menuText: "افتخارات", icon: Eftekharat, compName: "eftekharat" },
          { menuText: "تماس باما", icon: TamasBaMa, compName: "contact" },
        ].map((m, index) => (
          <BottomNavigationAction
            key={index}
            label={m.menuText}
            icon={
              <Avatar
                src={m.icon}
                sx={{
                  width: 32,
                  height: 32,
                }}
              />
            }
            onClick={() => handleComToShow(m.compName)}
            sx={{ color: "#c5c5c5", "& .Mui-selected": { color: "#fff" } }}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
}
